import React from 'react'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
const useStyles = makeStyles((theme) => ({
  logoImage: {
    height: '2rem',
    width: '2rem',
  },
}))

const IconText = ({
  icons,
  imgSrc,
  labelId,
  additionalTextCls,
  additionalImageCls,
}) => {
  const classes = useStyles()
  return (
    <div className="flex flex-row items-center content-center">
      {icons ? (
        icons
      ) : (
        <img
          src={imgSrc}
          className={clsx(classes.logoImage, additionalImageCls)}
          alt=""
        />
      )}

      <div className={clsx('ltr:ml-16 rtl:mr-16', additionalTextCls)}>
        <FormattedMessage id={labelId} />
      </div>
    </div>
  )
}

export default React.memo(IconText)
